import React, { useState, useEffect, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import "cropperjs/dist/cropper.css";
import { Link } from "react-router-dom";
import StudentRightsCheck from "./StudentRightsCheck";
import { Modal, ModalFooter } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import Cropper from "react-cropper";
import config from "../../Config";
import axios from "axios";
import moment from "moment";

const StudentUpdateProfile = (props) => {

  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [image, setImage] = useState("");
  const cropperRef = useRef(null);
  const [imageSelected, setImageSelected] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);

  const [Student, setStudent] = useState({});

  useEffect(() => {
    document.title = "Update Profile - Student Panel";
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ID: UserID
    };
    setLoading(true);
    var api_config = {
      method: 'post',
      url: config.base_url + 'Student/GetStudentByID',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };

    axios(api_config)
      .then(function (response) {
       //console.log(response.data.Student);
        if (response.data.status_code == 1) {
          setStudent(response.data.Student);
        }
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        toast.error('Network Error..', {
          position: toast.POSITION.TOP_RIGHT
        });
      });

  }, [UserID]);

  const handleShowModal = () => {
    setImage("");
    setImageSelected(false);
    setIsUpdated(false);
    cropperRef.current = null;
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setImage("");
    setImageSelected(false);
    setIsUpdated(false);
    setLoading(false);
    cropperRef.current = null;
  };

  const handleChooseAnother = () => {
    setImage("");
    setImageSelected(false);
    cropperRef.current = null;
  };


  const onChange = (e) => {
    e.preventDefault();
    const files = e.dataTransfer ? e.dataTransfer.files : e.target?.files;
    if (!files || files.length === 0) return;
    const file = files[0];
    if (!["image/jpeg", "image/png"].includes(file.type)) {
      toast.error("Please select a JPEG or PNG image.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Image must be less than 5 MB.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    const reader = new FileReader();
    reader.onload = () => setImage(reader.result);
    reader.readAsDataURL(file);
    setImageSelected(true);
    if (e.target) e.target.value = "";
  };

  const getCropData = () => {
    const cropper = cropperRef.current;
    if (!cropper) {
      toast.error("Please wait for the image to load, then try again.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    setLoading(true);
    try {
      const canvas = cropper.getCroppedCanvas({ maxWidth: 800, maxHeight: 800 });
      if (!canvas) {
        setLoading(false);
        toast.error("Could not crop image. Please try again.", { position: toast.POSITION.TOP_RIGHT });
        return;
      }
      const dataUrl = canvas.toDataURL("image/jpeg", 0.9);
      const base64 = dataUrl.replace(/^data:image\/\w+;base64,/, "");

      const data = {
        AccessKey: AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType: MemberType || "Student",
        Img_File: base64,
      };

      axios({
        method: "post",
        url: config.base_url + "Student/UpdatePhoto",
        headers: { "Content-Type": "application/json" },
        data: data,
      })
        .then(function (response) {
          setLoading(false);
          if (response.data.status_code === 1) {
            setIsUpdated(true);
            setImageSelected(false);
            toast.success("Photo updated successfully.", { position: toast.POSITION.TOP_RIGHT });
            setTimeout(() => {
              handleCloseModal();
              window.location.reload();
            }, 800);
          } else {
            toast.error(response.data.status_message || "Failed to update photo.", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        })
        .catch(function () {
          setLoading(false);
          toast.error("Failed to update photo. Please try again.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    } catch (err) {
      setLoading(false);
      toast.error("Could not process image. Please try again.", { position: toast.POSITION.TOP_RIGHT });
    }
  };

  const renderButtons = () => {
    if (imageSelected) {
      return (
        <>
          <button type="button" className="button button-outline" onClick={handleChooseAnother}>Choose another</button>
          <button type="button" className="button button-outline" onClick={handleCloseModal}>Close</button>
          <button type="button" className="button button-primary" disabled={loading} onClick={getCropData}>
            {loading ? "Saving…" : "Save Photo"}
          </button>
        </>
      );
    }
    if (isUpdated) {
      return (
        <button type="button" className="button button-outline" onClick={handleCloseModal}>Close</button>
      );
    }
    return null;
  };


  return (
    <>
      {/* <StudentPanelMenu /> */}
      <ToastContainer />
      <StudentRightsCheck />
      <Modal show={showModal} onHide={handleCloseModal} className="bs-modal upload-img-model">
        <Modal.Header closeButton>
          <Modal.Title>Update Profile Photo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            isUpdated ?
              <>
                <div className="text-center">

                  <p>Photo Updated Successfully</p>
                </div>

              </>
              :
              <>
                <div className="upload-photo-wrap student-profile-cropper-wrap">
                  {imageSelected ? (
                    <>
                      <div className="student-profile-cropper-container" style={{ minHeight: 360 }}>
                        <Cropper
                          src={image}
                          aspectRatio={1}
                          viewMode={2}
                          dragMode="move"
                          guides={true}
                          background={false}
                          responsive={true}
                          autoCropArea={0.8}
                          checkOrientation={false}
                          minCropBoxWidth={80}
                          minCropBoxHeight={80}
                          onInitialized={(instance) => {
                            cropperRef.current = instance;
                          }}
                          style={{ height: 360, width: "100%" }}
                        />
                      </div>
                      <p className="small text-muted mt-2 mb-0">Drag to reposition, then click Save Photo.</p>
                    </>
                  ) : (
                    <div className="choose-photo">
                      <label htmlFor="ChoosePhoto">
                        <i className="ri-upload-cloud-line"></i>
                        <span>Browse Photo</span>
                        <input id="ChoosePhoto" accept="image/jpeg,image/png" type="file" onChange={onChange} />
                      </label>
                    </div>
                  )}
                </div>
              </>

          }
        </Modal.Body>
        <ModalFooter>
          {renderButtons()}
        </ModalFooter>
      </Modal>
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/student-panel/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Update Profile
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Update Profile</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container body-content">
        <div className="student-card student-update-profile-page">
          {loading && !Student?.Student_ID ? (
            <div className="card border-0 shadow-sm">
              <div className="card-body text-center py-5">
                <Spinner animation="border" role="status" />
                <p className="mt-2 mb-0 text-muted">Loading profile...</p>
              </div>
            </div>
          ) : (
          <div className="card student-profile-card">
            {/* Top band + centered photo overlapping */}
            <div className="student-profile-banner" />
            <div className="student-profile-photo-wrap">
              <button
                type="button"
                className="student-profile-photo-btn"
                onClick={handleShowModal}
                aria-label="Change profile photo"
              >
                <span className="student-profile-photo-frame">
                  <img
                    src={config.StudentImagePath + (Student.Registration_No || "") + ".jpg"}
                    alt={Student.Student_Name ? `Photo of ${Student.Student_Name}` : "Profile"}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = config.StudentImagePath + "default.png";
                    }}
                  />
                  <span className="student-profile-photo-edit">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="22" height="22">
                      <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
                    </svg>
                    <span>Change photo</span>
                  </span>
                </span>
              </button>
            </div>

            {/* Name and ID under photo */}
            <div className="student-profile-head">
              <h1 className="student-profile-name">{Student.Student_Name}</h1>
              {Student.Father_Name && (
                <p className="student-profile-father">{Student.Father_Name}</p>
              )}
              <span className="student-profile-id">ID {Student.Student_ID}</span>
            </div>

            <div className="card-body student-profile-body">
              {/* Academic info */}
              <div className="student-academic-badges">
                <span className="badge-pill">
                  <span className="badge-pill-label">Wing</span>
                  <span className="badge-pill-value">{Student.SelectedClass?.SelectedWing?.Wing_Name ?? "—"}</span>
                </span>
                <span className="badge-pill">
                  <span className="badge-pill-label">Class</span>
                  <span className="badge-pill-value">{Student.SelectedClass?.Class_Name ?? "—"}</span>
                </span>
                <span className="badge-pill">
                  <span className="badge-pill-label">Section</span>
                  <span className="badge-pill-value">{Student.SelectedSection?.Section_Name ?? "—"}</span>
                </span>
              </div>

              {/* Personal details grid */}
              <section className="student-profile-section">
                <h6 className="student-profile-section-title">Personal details</h6>
                <div className="student-detail-grid">
                  <div className="detail-row">
                    <span className="detail-label">Registration No</span>
                    <span className="detail-value">{Student.Registration_No && Student.Registration_No.length !== 0 ? Student.Registration_No : "—"}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Mobile No</span>
                    <span className="detail-value">{Student.Contact_Mobile && Student.Contact_Mobile.length !== 0 ? Student.Contact_Mobile : "—"}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Status</span>
                    <span className="detail-value">
                      {Student.Status_Type_Id === 1 ? "Normal" : Student.Status_Type_Id === 2 ? "Struck Off" : Student.Status_Type_Id === 3 ? "Left" : Student.Status_Type_Id === 4 ? "Study Complete" : Student.Status_Type_Id === 5 ? "SLC" : Student.Status_Type_Id === 6 ? "Freezed" : "Not Enrolled"}
                    </span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Gender</span>
                    <span className="detail-value">{Student.Gender === "male" ? "Male" : Student.Gender === "female" ? "Female" : (Student.Gender || "—")}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Bay Form No</span>
                    <span className="detail-value">{Student.Bay_Form_No && Student.Bay_Form_No.length !== 0 ? Student.Bay_Form_No : "—"}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Date of Birth</span>
                    <span className="detail-value">{Student.Date_Of_Birth ? moment(Student.Date_Of_Birth).format("DD/MM/YYYY") : "—"}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Date of Joining</span>
                    <span className="detail-value">{Student.Date_Of_Joining ? moment(Student.Date_Of_Joining).format("DD/MM/YYYY") : "—"}</span>
                  </div>
                </div>
              </section>

              {/* Address */}
              <section className="student-profile-section">
                <h6 className="student-profile-section-title">Address</h6>
                <div className="student-address-box">
                  <i className="ri-map-pin-fill student-address-icon" aria-hidden="true" />
                  <p className="student-address-text">{Student.Permanent_Address && Student.Permanent_Address.length !== 0 ? Student.Permanent_Address : "—"}</p>
                </div>
              </section>
            </div>
          </div>
          )}
        </div>
      </div>
    </>
  );
};

export default StudentUpdateProfile;
